export const task = {
	type: 'object',
	required: [
		'points',
		'sample',
		'type'
	],
	properties: {
		points: {
			type: ['integer', 'string'],
			pattern: '^\\d+$'
		},
		sample: {
			type: ['integer', 'string'],
			pattern: '^\\d+$'
		},
		type: {
			type: 'string',
			enum: ['quiz', 'essay', 'multiple', 'spellcheck', 'connect', 'upload']
		},
		description: {
			type: ['string', 'null']
		}
	},
	allOf: [
		{
			if: {
				properties: {
					type: {
						enum: ['quiz']
					}
				}
			},
			then: {
				properties: {
					questions: {
						type: 'array',
						items: {
							$ref: '/task-quiz-questions'
						}
					}
				}
			}
		},
		{
			if: {
				properties: {
					type: {
						enum: ['essay', 'multiple', 'upload']
					}
				}
			},
			then: {
				properties: {
					questions: {
						type: 'array',
						items: {
							$ref: '/task-default-questions'
						}
					}
				}
			}
		},
		{
			if: {
				properties: {
					type: {
						enum: ['spellcheck']
					}
				}
			},
			then: {
				properties: {
					questions: {
						type: 'array',
						items: {
							$ref: '/task-spellcheck-questions'
						}
					}
				}
			}
		},
		{
			if: {
				properties: {
					type: {
						enum: ['connect']
					}
				}
			},
			then: {
				properties: {
					questions: {
						type: 'array',
						items: {
							$ref: '/task-connect-questions'
						}
					}
				}
			}
		},
	],
	errorMessage: {
		required: 'validationFieldRequired',
		properties: {
			points: 'validationFieldRequired',
			sample: 'validationFieldRequired',
			type: 'validationFieldRequired',
		}
	}
};
